import React from "react";
import Mobileapp from '../../assets/mobile-app.webp';
import playstore from '../../assets/googleplay.webp';
import appstore from '../../assets/appstore.webp';
import ComponenetHeader from "../common/ComponenetHeader";
import { Helmet } from "react-helmet";

const MobileAppLink = () =>{

    return(
        <>

        <ComponenetHeader
           name={'Mobile App'}
        />

            <Helmet>
                <link rel="canonical" href="/app"/>
                <title>Truck Repair App | 24/7 Truck Repair Services | Download Now</title>
                <meta name="keywords" content="truck repair app, truck breakdown near me, truck breakdown, breakdown truck service,truck breakdown app, tow trucks service near me"/>
                <meta name="description" content="Download the Truck Repair App for instant access to 24/7 truck repair and roadside services. Fast, reliable support wherever you are—stay road-ready anytime" />

                <meta property="og:title" content="Truck Repair App | 24/7 Truck Repair Services | Download Now" />
                <meta property="og:description" content="Download the Truck Repair App for instant access to 24/7 truck repair and roadside services. Fast, reliable support wherever you are—stay road-ready anytime" />
            </Helmet>

        <section className="d_app_section text-left">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-md-6">
                        <div className="app_screenshot text-center">
                         <img src={Mobileapp} className='img-fluid' alt='Mobile App'/>
                        </div>
                    </div>

                    <div className="col-md-6 px-md-4 px-3">
                        <div className="app_content">
                            <h1 className="seo_t m-0 mb-3">Download App</h1>
                            <h3>Online Road Services Mobile App</h3>
                            <p className="mb-1">
                            ORS is the largest online directory service provider specializing in the
                            trucking industry. Our comprehensive directory includes listings for truck
                            repair shops, <a href="https://onlineroadservices.com/contact">trailer repair shop</a>,
                            weigh stations, scales, locksmiths, reefer repair shops, insurance companies,
                            truck/trailer rentals, and more. We provide motor carrier companies, drivers,
                            and truck owner-operators with a simple way to connect with the right service
                            providers when faced with a truck breakdown or emergency.
                            </p>

                            <p>
                            Our customer service team is available 24/7/365 to assist with any questions about our
                            software or help you find breakdown truck service in your area. Whether you're looking
                            for a truck repair app or searching for tow trucks service near you, our network of
                            service providers is growing rapidly to cover every city, state, and region in North
                            America. With the truck breakdown app, you can easily find mobile truck breakdown near
                            you services to get back on the road quickly and safely.
                            </p>

                            <h5>Now Available on iOS and Android</h5>

                            <div className="app_btn_img d-flex">
                                <a target="blank" href="https://apps.apple.com/in/app/online-road-service/id6444897798"><img src={appstore} className='img-fluid' alt='App Store'/></a>
                                <a target="blank" href="https://play.google.com/store/apps/details?id=com.ors.roadservice"><img src={playstore} className='img-fluid' alt='Play Store'/></a>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </section>


        </>
    );
};

export default MobileAppLink;